//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import domainDialog from './components/domainDialog.vue';
import releaseRecord from './releaseRecord/index.vue';
import experienceCode from './experienceCode/index.vue';
import version from './components/version.vue';
import qrcode from './components/qrCode.vue';
import {
  getaccountbasicinfo,
  domain,
  setwebviewdomain,
  qrcodejumpget,
  qrcodejumppublish,
  memberauth,
  bindtester,
  unbindtester,
  getVersion,
  // getQrcode,
  // submitAudit,
  releaseAudit,
  revertcoderelease,
  changeVisitstatus,
  undocodeaudit,
  getLastAuditstatus,
  //   setprivacysetting,
} from '@/api/miniProgramManagement.js';
import { gettemplatelist } from '@/api/templateManagement.js';
import { getconfigbyappid } from '@/api/configurationManagement.js';
import { AUDIT_STATUS } from '@/utils/constant';
import globalMix from '../../../mixin/global.js';
export default {
  components: {
    domainDialog,
    releaseRecord,
    experienceCode,
    version,
    qrcode,
  },
  mixins: [globalMix],
  data() {
    return {
      queryAppid: '',
      activeName: '',
      audit_version: {}, // 审核版本
      commit_version: {}, // 体验版本
      release_version: {}, // 线上版本
      templateVisible: false, // 上传体验版本弹窗控制
      lineVersonDetailVisible: false, // 线上版本详情弹窗控制
      auditVersonDetailVisible: false, // 审核版本详情弹窗控制
      lineVersonDialogVisible: false, // 线上版本弹窗控制
      pauseVersonDialogVisible: false, // 暂停服务弹窗控制
      auditVersonDialogVisible: false, // 发布审核版本弹窗控制
      auditDialogVisible: false, // 提交审核弹窗控制
      cancelAuditDialogVisible: false, // 撤销审核弹窗控制
      cancelAuditLoading: false, // 撤销loading
      nickname: '', // 小程序名称
      appid: '', // 小程序appId
      head_image_url: '', // 小程序logo
      lineVersonDetail: {}, // 线上版本详情
      auditVersonDetail: {}, // 审核版本详情
      experienceVersonDetail: {}, // 体验版本详情
      vsersonData: [], // 选择模板数据展示
      allData: [], // 全部模板数据
      vsersonDataLoading: false,
      setVerson: {}, // 选定设置为体验版数据
      setVersonParams: {
        page_index: 1,
        page_size: 5,
      },
      setVersonDataTotal: 0, // 选择设置体验版本表格条数
      domainTableData: [
        { name: 'request合法域名', path: [] },
        { name: 'socket合法域名', path: [] },
        { name: 'uploadFile合法域名', path: [] },
        {
          name: 'downloadFile合法域名',
          path: [],
        },
      ], // 服务器域名
      businessDomainData: [{ name: '业务域名', path: [] }], // 业务域名
      domainDialogVisible: false, // request服务器域名设置弹窗控制
      socketDomainVisible: false, // socket域名弹窗控制
      uploadFileDomainVisible: false, // uploadFile域名弹窗控制
      downloadFileDoaminVisible: false, // downloadFile域名弹窗控制
      busunessDomainVisible: false, // 业务域名设置弹窗控制
      addDomain: [], // 添加服务器域名设置地址
      addSocketDomain: [], // 添加socket域名
      addUploadFileDomain: [], // 添加uploadFile域名
      addDownloadFileDomain: [], // 添加downloadFile域名
      addBusinessDomain: [], // 添加业务域名设置地址
      qcTableData: [], // 二维码表格数据
      wx: '', // 微信账号
      experiencer: '', // 体验者
      experiencerTableData: [], // 体验者表格数据
      domainLoading: false, // 服务器域名返回Loading
      businessDomainLoading: false, // 业务域名返回loading
      // ext_json
      jsonList: [],
      // 隐私指引
      privacy: 1, // 设置隐私指引
      btnDisabile: false,
      isReaded: false, // 是否已阅读审核要求
    };
  },
  computed: {
    qcNum() {
      return 100 - this.qcTableData.length;
    },
    extList() {
      const common = []; // 普通
      const standard = []; // 标准
      this.jsonList.forEach((item) => {
        let json = {};
        try {
          json = JSON.parse(item.content);
        } catch (err) {
          console.log(err);
        }
        if (
          !Object.keys(json).some((key) => {
            return !['ext', 'window', 'extAppid'].includes(key);
          })
        ) {
          standard.push(item);
        }
        common.push(item);
      });
      return [
        // 0 : 普通模板
        common,
        // 1: 标准模板
        standard,
      ];
    },
    canCancelAudit() {
      return AUDIT_STATUS[this.audit_version.status] === '审核中';
    },
    auditStatus() {
      return AUDIT_STATUS[this.audit_version.status];
    },
  },
  watch: {
    privacy() {
      this.btnDisabile = false;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.queryAppid = this.$route.query.appid;
      this.activeName = this.$route.query.active;
      console.log(this.activeName);
      this.getInfo();
      if (this.activeName === 'first') {
        this.getVersonList();
      }
      if (this.activeName === 'second') {
        this.getDomain();
        this.getWebViewDomain();
      }
      if (this.activeName === 'third') {
        this.getqrcodejumpget();
      }
      if (this.activeName === 'fourth') {
        this.getMemberauth();
      }
      if (this.activeName === 'sixth') {
        this.btnDisabile = false;
      }
    },
    // 暂停服务
    handleChangeStatus() {
      changeVisitstatus({
        appid: this.queryAppid,
        path: '/wxa/change_visitstatus',
        body: JSON.stringify({
          action: 'close',
        }),
      })
        .then(() => {
          this.$message.success('暂停成功');
          this.pauseVersonDialogVisible = false;
        })
        .catch(() => {
          this.$message.error('暂停失败');
          this.pauseVersonDialogVisible = false;
        });
    },
    // 版本回退
    handleRevert() {
      revertcoderelease({
        app_id: this.queryAppid,
        method: 'GET',
      })
        .then(() => {
          this.$message.success('回退成功');
          this.lineVersonDialogVisible = false;
          this.initData();
        })
        .catch(() => {
          this.$message.error('回退失败');
          this.lineVersonDialogVisible = false;
        });
    },
    // 发布审核版本
    handleReleaseAudit() {
      releaseAudit({ app_id: this.queryAppid, body: '{}' })
        .then(() => {
          this.$message.success('发布成功');
          this.auditVersonDialogVisible = false;
          if (this.activeName === 'first') {
            this.getVersonList();
          }
        })
        .catch(() => {
          this.$message.error('发布失败');
          this.auditVersonDialogVisible = false;
        });
    },
    // 下一步提交审核
    next() {
      this.$router.push({
        name: 'mini-submit-audit',
        query: {
          appid: this.queryAppid,
        },
      });
      // submitAudit({ app_id: this.queryAppid })
      //   .then(res => {
      //     console.log(res);
      //     this.$message.success('提交成功');
      //     this.auditDialogVisible = false;
      //   })
      //   .catch(err => {
      //     this.$message.error(err.errmsg);
      //     this.auditDialogVisible = false;
      //   });
    },
    // 解除绑定人员
    handleUntie(val) {
      this.$confirm('确定要解除绑定吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          unbindtester({
            app_id: this.queryAppid,
            wechat_id: val.wechat_id,
            body: JSON.stringify({ wechatid: val.wechat_id }),
          })
            .then(() => {
              this.$message.success('解除成功！');
              this.getMemberauth();
            })
            .catch(() => {
              this.$message.success('解除失败！');
            });
        })
        .catch(() => {});
    },
    // 查询体验人员
    handleInquire() {
      const req = {
        app_id: this.queryAppid,
        action: 'get_experiencer',
        wechat_id: this.experiencer,
      };
      memberauth(req)
        .then((res) => {
          console.log('体验人员管理列表', res);
          this.experiencerTableData = res.list || [];
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 绑定体验人员
    handleBindWx() {
      const req = {
        app_id: this.queryAppid,
        wechat_id: this.wx,
        body: JSON.stringify({ wechatid: this.wx }),
      };
      bindtester(req)
        .then(() => {
          this.$message.success('绑定成功！');
          this.wx = '';
          this.getMemberauth();
        })
        .catch(() => {
          this.$message.error('绑定失败！');
        });
    },
    // 获取体验管理人员列表
    getMemberauth() {
      const req = {
        app_id: this.queryAppid,
        action: 'get_experiencer',
        wechat_id: this.experiencer,
      };
      memberauth(req).then((res) => {
        console.log('体验人员管理列表', res);
        this.experiencerTableData = res.list || [];

        console.log('this.experiencerTableData', this.experiencerTableData);
      });
    },
    // 设置隐私指引
    async setprivacy() {
      if (this.privacy === 1) {
        this.btnDisabile = true;
        this.$message({
          message: '设置成功',
          type: 'success',
        });
      } else {
        this.$router.push({
          name: 'mini-user-privacy',
          query: {
            appid: this.queryAppid,
          },
        });
      }
    },
    // 小程序二维码发布
    handlePublish(val) {
      console.log(val);
      this.$confirm(
        '发布后，用户将可以通过扫描普通二维码打开小程序，配置在5分钟内生效。发布后仍可修改测试链接和测试范围进行调试，测试不影响已发布线上的服务, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          qrcodejumppublish({ prefix: val.prefix, app_id: this.queryAppid })
            .then(() => {
              this.$message({
                type: 'success',
                message: '发布成功!',
              });
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '发布失败!',
              });
            });
        })
        .catch(() => {});
    },
    // 小程序二维码详情跳转
    handleQcDetail(val) {
      console.log(val);
      const data = JSON.stringify(val);
      localStorage.setItem('qc', data);
      this.$router.push({
        name: 'mini-qc-code',
        query: {
          appid: this.queryAppid,
          type: 'edit',
        },
      });
    },
    // 获取小程序二维码
    getqrcodejumpget() {
      qrcodejumpget({
        appid: this.queryAppid,
        path: '/cgi-bin/wxopen/qrcodejumpget',
        body: '{}',
      })
        .then((data) => {
          console.log('获取小程序二维码', data);
          const res = JSON.parse(data?.body || '{}');
          this.qcTableData = res.rule_list;
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 获取业务域名
    getWebViewDomain() {
      this.businessDomainLoading = true;
      setwebviewdomain({
        appid: this.queryAppid,
        path: '/wxa/setwebviewdomain',
        body: JSON.stringify({ action: 'get' }),
      })
        .then((data) => {
          console.log('获取业务域名', data);
          const res = JSON.parse(data?.body || '{}');
          this.businessDomainData[0].path = res.webviewdomain;
          this.businessDomainLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
          this.businessDomainLoading = false;
        });
    },
    // 获取服务器域名
    getDomain() {
      this.domainLoading = true;
      domain({
        appid: this.queryAppid,
        path: '/wxa/modify_domain',
        body: JSON.stringify({ action: 'get' }),
      })
        .then((data) => {
          console.log('获取域名', data);
          const res = JSON.parse(data?.body || '{}');
          this.domainTableData[0].path = res.requestdomain;
          this.domainTableData[1].path = res.wsrequestdomain;
          this.domainTableData[2].path = res.uploaddomain;
          this.domainTableData[3].path = res.downloaddomain;
          this.domainLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
          this.domainLoading = false;
        });
    },
    // 获取小程序版本列表
    getVersonList() {
      getVersion({ app_id: this.queryAppid })
        .then((res) => {
          console.log('版本列表', res);
          this.audit_version = res.audit_version || {};
          this.commit_version = res.commit_version || {};
          this.release_version = res.release_version || {};
          this.lineVersonDetail = res.release_version || {};
          this.auditVersonDetail = res.audit_version || {};
          this.experienceVersonDetail = res.commit_version || {};
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 获取小程序信息
    getInfo() {
      getaccountbasicinfo({ appid: this.queryAppid, path: '/cgi-bin/account/getaccountbasicinfo' })
        .then((data) => {
          console.log('小程序信息', data);
          const res = JSON.parse(data?.body || '{}');
          this.nickname = res.nickname;
          this.appid = res.appid;
          this.head_image_url = res.head_image_info.head_image_url;
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 添加业务域名
    handleBusinessDoamin(val) {
      console.log('业务域名', val);
      // if (val.length > 0) {
      //   const arr = val.map((item) => {
      //     return `https://${item}`;
      //   });
      //   this.addBusinessDomain = arr;
      //   const req = {
      //     app_id: this.queryAppid,
      //     action: 'add',
      //     webviewdomain: this.addBusinessDomain,
      //   };
      //   setwebviewdomain(req)
      //     .then(() => {
      //       this.$message.success('修改成功');
      //       this.busunessDomainVisible = false;
      //       this.getWebViewDomain();
      //     })
      //     .catch((err) => {
      //       this.$message.error(err.errmsg);
      //     });
      // }
      if (val.length < 1) {
        this.$message.error('没有添加任何数据');
        return false;
      }
      const req = {
        appid: this.queryAppid,
        path: '/wxa/setwebviewdomain',
        body: JSON.stringify({
          action: 'add',
          webviewdomain: val,
        }),
      };
      setwebviewdomain(req)
        .then(() => {
          this.$message.success('修改成功');
          this.busunessDomainVisible = false;
          this.getWebViewDomain();
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 添加downloadFile合法域名
    handleDownloadFileDomain(val) {
      console.log('downloadFile合法域名', this.addDownloadFileDomain);
      // if (val.length > 0) {
      //   const arr = val.map((item) => {
      //     return `https://${item}`;
      //   });
      //   this.addDownloadFileDomain = arr;
      //   const req = {
      //     app_id: this.queryAppid,
      //     action: 'add',
      //     requestdomain: [],
      //     wsrequestdomain: [],
      //     uploaddomain: [],
      //     downloaddomain: this.addDownloadFileDomain,
      //   };
      //   domain(req)
      //     .then(() => {
      //       this.$message.success('修改成功');
      //       this.downloadFileDoaminVisible = false;
      //       this.getDomain();
      //     })
      //     .catch((err) => {
      //       this.$message.error(err.errmsg);
      //     });
      // }
      if (val.length < 1) {
        this.$message.error('没有添加任何数据');
        return false;
      }
      const req = {
        appid: this.queryAppid,
        path: '/wxa/modify_domain',
        body: JSON.stringify({
          action: 'add',
          requestdomain: [],
          wsrequestdomain: [],
          uploaddomain: [],
          downloaddomain: val,
        }),
      };
      domain(req)
        .then(() => {
          this.$message.success('修改成功');
          this.downloadFileDoaminVisible = false;
          this.getDomain();
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 添加uploadFile合法域名
    handleUploadFileDomain(val) {
      console.log('uploadFile合法域名', this.addUploadFileDomain);
      // if (val.length > 0) {
      //   const arr = val.map((item) => {
      //     return `https://${item}`;
      //   });
      //   this.addUploadFileDomain = arr;
      //   const req = {
      //     app_id: this.queryAppid,
      //     action: 'add',
      //     requestdomain: [],
      //     wsrequestdomain: [],
      //     uploaddomain: this.addUploadFileDomain,
      //     downloaddomain: [],
      //   };
      //   domain(req)
      //     .then(() => {
      //       this.$message.success('修改成功');
      //       this.uploadFileDomainVisible = false;
      //       this.getDomain();
      //     })
      //     .catch((err) => {
      //       this.$message.error(err.errmsg);
      //     });
      // }
      if (val.length < 1) {
        this.$message.error('没有添加任何数据');
        return false;
      }
      const req = {
        appid: this.queryAppid,
        path: '/wxa/modify_domain',
        body: JSON.stringify({
          action: 'add',
          requestdomain: [],
          wsrequestdomain: [],
          uploaddomain: val,
          downloaddomain: [],
        }),
      };
      domain(req)
        .then(() => {
          this.$message.success('修改成功');
          this.uploadFileDomainVisible = false;
          this.getDomain();
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 添加socket合法域名
    handleSocketDomain(val) {
      console.log('socket合法域名', val);
      // if (val.length > 0) {
      //   const arr = val.map((item) => {
      //     return `https://${item}`;
      //   });
      //   this.addSocketDomain = arr;
      //   const req = {
      //     app_id: this.queryAppid,
      //     action: 'add',
      //     requestdomain: [],
      //     wsrequestdomain: this.addSocketDomain,
      //     uploaddomain: [],
      //     downloaddomain: [],
      //   };
      //   domain(req)
      //     .then(() => {
      //       this.$message.success('修改成功');
      //       this.socketDomainVisible = false;
      //       this.getDomain();
      //     })
      //     .catch((err) => {
      //       this.$message.error(err.errmsg);
      //     });
      // }
      if (val.length < 1) {
        this.$message.error('没有添加任何数据');
        return false;
      }
      const req = {
        appid: this.queryAppid,
        path: '/wxa/modify_domain',
        body: JSON.stringify({
          action: 'add',
          requestdomain: [],
          wsrequestdomain: val,
          uploaddomain: [],
          downloaddomain: [],
        }),
      };
      domain(req)
        .then(() => {
          this.$message.success('修改成功');
          this.socketDomainVisible = false;
          this.getDomain();
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    // 添加request合法域名
    handleReqDomain(val) {
      console.log('request合法域名', val);
      // if (val.length > 0) {
      //   const arr = val.map((item) => {
      //     return `https://${item}`;
      //   });
      //   this.addDomain = arr;
      //   const req = {
      //     app_id: this.queryAppid,
      //     action: 'add',
      //     requestdomain: this.addDomain,
      //     wsrequestdomain: [],
      //     uploaddomain: [],
      //     downloaddomain: [],
      //   };
      //   domain(req)
      //     .then(() => {
      //       this.$message.success('修改成功');
      //       this.domainDialogVisible = false;
      //       this.getDomain();
      //     })
      //     .catch((err) => {
      //       this.$message.error(err.errmsg);
      //     });
      // }
      if (val.length < 1) {
        this.$message.error('没有添加任何数据');
        return false;
      }
      const req = {
        appid: this.queryAppid,
        path: '/wxa/modify_domain',
        body: JSON.stringify({
          action: 'add',
          requestdomain: val,
          wsrequestdomain: [],
          uploaddomain: [],
          downloaddomain: [],
        }),
      };
      domain(req)
        .then(() => {
          this.$message.success('修改成功');
          this.domainDialogVisible = false;
          this.getDomain();
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },

    // 删除业务域名
    handleDelBusinessDoamin(val) {
      console.log(val);
      if (val.length > 0) {
        this.addBusinessDomain = val;
        const req = {
          appid: this.queryAppid,
          path: '/wxa/setwebviewdomain',
          body: JSON.stringify({
            action: 'delete',
            webviewdomain: this.addBusinessDomain,
          }),
        };
        setwebviewdomain(req)
          .then(() => {
            this.$message.success('修改成功');
            this.busunessDomainVisible = false;
            this.getWebViewDomain();
          })
          .catch((err) => {
            this.$message.error(err.errmsg);
          });
      }
    },
    // 删除downFile合法域名
    handleDelDownloadFileDomain(val) {
      console.log(val);
      if (val.length > 0) {
        this.addDownloadFileDomain = val;
        const req = {
          appid: this.queryAppid,
          path: '/wxa/modify_domain',
          body: JSON.stringify({
            action: 'delete',
            requestdomain: [],
            wsrequestdomain: [],
            uploaddomain: [],
            downloaddomain: this.addDownloadFileDomain,
          }),
        };
        domain(req)
          .then(() => {
            this.$message.success('修改成功');
            this.downloadFileDoaminVisible = false;
            this.getDomain();
          })
          .catch((err) => {
            this.$message.error(err.errmsg);
          });
      }
    },
    // 删除uploadFile合法域名
    handleDelUploadFileDomain(val) {
      console.log(val);
      if (val.length > 0) {
        this.addUploadFileDomain = val;
        const req = {
          appid: this.queryAppid,
          path: '/wxa/modify_domain',
          body: JSON.stringify({
            action: 'delete',
            requestdomain: [],
            wsrequestdomain: [],
            uploaddomain: this.addUploadFileDomain,
            downloaddomain: [],
          }),
        };
        domain(req)
          .then(() => {
            this.$message.success('修改成功');
            this.uploadFileDomainVisible = false;
            this.getDomain();
          })
          .catch((err) => {
            this.$message.error(err.errmsg);
          });
      }
    },
    // 删除socket合法域名
    handleDelSocketDomain(val) {
      console.log(val);
      if (val.length > 0) {
        this.addSocketDomain = val;
        const req = {
          appid: this.queryAppid,
          path: '/wxa/modify_domain',
          body: JSON.stringify({
            action: 'delete',
            requestdomain: [],
            wsrequestdomain: this.addSocketDomain,
            uploaddomain: [],
            downloaddomain: [],
          }),
        };
        domain(req)
          .then(() => {
            this.$message.success('修改成功');
            this.socketDomainVisible = false;
            this.getDomain();
          })
          .catch((err) => {
            this.$message.error(err.errmsg);
          });
      }
    },
    // 删除request合法域名
    handleDelReqDomain(val) {
      console.log(val);
      if (val.length > 0) {
        this.addDomain = val;
        const req = {
          appid: this.queryAppid,
          path: '/wxa/modify_domain',
          body: JSON.stringify({
            action: 'delete',
            requestdomain: this.addDomain,
            wsrequestdomain: [],
            uploaddomain: [],
            downloaddomain: [],
          }),
        };
        domain(req)
          .then(() => {
            this.$message.success('修改成功');
            this.domainDialogVisible = false;
            this.getDomain();
          })
          .catch((err) => {
            this.$message.error(err.errmsg);
          });
      }
    },
    // 域名修改弹窗取消
    handleCancel() {
      this.domainDialogVisible = false;
      this.socketDomainVisible = false;
      this.uploadFileDomainVisible = false;
      this.downloadFileDoaminVisible = false;
      this.busunessDomainVisible = false;
    },
    // 业务域名修改
    handleBusinessDomainModify() {
      this.busunessDomainVisible = true;
    },
    // 域名修改
    handleDomainModify(val) {
      console.log(val);
      if (val === 'request合法域名') {
        this.domainDialogVisible = true;
      }
      if (val === 'socket合法域名') {
        this.socketDomainVisible = true;
      }
      if (val === 'uploadFile合法域名') {
        this.uploadFileDomainVisible = true;
      }
      if (val === 'downloadFile合法域名') {
        this.downloadFileDoaminVisible = true;
      }
    },
    // 提交审核
    handleAudit() {
      this.auditDialogVisible = true;
    },

    // 审核版本详情弹窗
    async handleAuditDetail() {
      this.auditVersonDetailVisible = true;
      const data = await getLastAuditstatus({
        appid: this.queryAppid,
        path: '/wxa/get_latest_auditstatus',
        method: 'GET',
      });
      const res = JSON.parse(data?.body || '{}');
      console.log('res', res);
      this.audit_version.Status = res.status;
    },
    // 线上版本详情弹窗
    handleLineDetail() {
      this.lineVersonDetailVisible = true;
    },
    // 线上版本设置弹窗
    handleLineCommand(val) {
      this.lineVersonDialogVisible = val.command;
      this.pauseVersonDialogVisible = val.pause;
      this.auditVersonDialogVisible = val.audit;
    },
    handleSetPath() {
      this.$refs.qrcode.opencode({ type: 3 });
    },
    // 撤销审核
    async undocodeaudit() {
      try {
        this.cancelAuditLoading = true;
        await undocodeaudit({ app_id: this.queryAppid });
        this.cancelAuditLoading = false;
        this.cancelAuditDialogVisible = false;
        this.initData();
      } catch (err) {
        console.error(err);
        this.cancelAuditLoading = false;
        this.$message.error(`撤销失败，请稍后重试${err.message || ''}`);
      }
    },
    // 取消上传体验版本弹窗
    handleCancelVersion() {
      this.templateVisible = false;
      this.setVerson = {};
    },
    // 上传体验版本
    handleUploadVersion() {
      let jsonStr = {};
      try {
        if (this.setVerson.ext_json) {
          jsonStr = JSON.parse(this.setVerson.ext_json);
        } else {
          this.$message.error('请设置ext_json');
          return;
        }
      } catch (err) {
        console.log(err);
      }
      const req = {
        template_id: this.setVerson.template_id,
        ext_json: JSON.stringify({
          ...jsonStr,
          extAppid: this.queryAppid,
        }),
      };
      this.$refs.inputVersion.showdialog(
        { app_id: this.queryAppid },
        {
          ...req,
          user_version: this.setVerson.user_version,
          user_desc: this.setVerson.user_desc,
        },
      );
    },
    // 上传体验版本成功
    UploadVersionSucceed() {
      this.templateVisible = false;
      this.$message.success('上传成功');
      this.getVersonList();
    },
    // 选择体验版本上传
    handleCurrentChange(val) {
      this.setVerson = val;
    },
    // 选择设置体验版本表格翻页
    handleVersonCurrent(val) {
      this.vsersonData = this.allData.slice(
        (val - 1) * this.setVersonParams.page_size,
        val * this.setVersonParams.page_size,
      );
    },
    // 设置体验版本弹窗
    handleSetVerson() {
      this.templateVisible = true;
      this.vsersonDataLoading = true;
      gettemplatelist({ app_id: this.queryAppid })
        .then((res) => {
          this.allData = (res.list || []).sort((a, b) => b.template_id - a.template_id);
          this.vsersonData = this.allData.slice(0, this.setVersonParams.page_size);
          this.setVersonDataTotal = this.allData.length;
          // 获取json列表
          if (this.allData.length > 0) {
            this.getJsonList();
          }
          this.vsersonDataLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
          this.vsersonDataLoading = false;
        });
    },
    async getJsonList() {
      try {
        const data = await getconfigbyappid({ app_id: this.queryAppid });
        this.jsonList = data.list || [];

        // 默认json
        this.allData = this.allData.map((item) => {
          return {
            ...item,
            ext_json: this.extList[item.template_type][0]?.content || '',
          };
        });

        this.vsersonData = this.vsersonData.map((item) => {
          return {
            ...item,
            ext_json: this.extList[item.template_type][0]?.content || '',
          };
        });
      } catch (err) {
        console.log(err);
      }
    },
    // tab切换
    handleClickTab(activeName, oldActiveName) {
      console.log(activeName, oldActiveName);
      if (activeName === 'first') {
        this.getVersonList();
      }
      if (activeName === 'second') {
        this.getDomain();
        this.getWebViewDomain();
      }
      if (activeName === 'third') {
        this.getqrcodejumpget();
      }
      if (activeName === 'fourth') {
        this.getMemberauth();
      }
      if (this.activeName === 'sixth') {
        this.btnDisabile = false;
      }
    },
    // 添加二维码
    handleToCode() {
      this.$router.push({
        name: 'mini-qc-code',
        query: {
          appid: this.queryAppid,
          type: 'add',
        },
      });
    },
    goBack() {
      this.$router.history.go(-1);
    },
  },
};
